import React, { memo, useContext } from 'react'

import MarkdownDataContext from '~contexts/MarkdownDataContext'
import TabbedCodeBlocks from '~components/TabbedCodeBlocks'

const byIdAndVariant = (id, variant) => (
  sample => (sample.key === id && sample.variant === variant)
)
  
const Samples = ({
  id,
  variant = 'default'
}) => {
  const data = useContext(MarkdownDataContext)
  const samples = data.samples?.filter?.(byIdAndVariant(id, variant)) || []

  return (
    <>
      { data.samples?.[0] && (
        <TabbedCodeBlocks samples={samples} />
      )}
    </>
  )  
}

export default memo(Samples)